import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from '../utils/useIsMobile';

const API = (process.env.REACT_APP_API_URL || '/api');

const LandingPage = () => {
  const isMobile = useIsMobile();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API}/auth/public-stats`)
      .then(r => r.json())
      .then(d => setStats(d))
      .catch(() => setStats({ students: null, companies: null, positions: null }));
  }, []);

  // Landing koyu temalı: body arka planını ve mobil tarayıcı UI rengini koyuya çek
  // (iOS'ta üst status bar / alt overscroll beyaz görünmesin). Çıkışta geri al.
  useEffect(() => {
    const prevBg = document.body.style.background;
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    const prevTheme = themeMeta?.getAttribute('content');
    document.body.style.background = '#0f172a';
    if (themeMeta) themeMeta.setAttribute('content', '#0f172a');
    return () => {
      document.body.style.background = prevBg;
      if (themeMeta && prevTheme != null) themeMeta.setAttribute('content', prevTheme);
    };
  }, []);

  const studentFeatures = [
    { icon: '🎯', title: 'Akıllı Eşleştirme', desc: 'Becerilerine ve profiline göre uygun üye şirketlerle otomatik eşleşirsin.' },
    { icon: '🏆', title: 'CTF & Sertifika Profili', desc: 'Hack The Box, TryHackMe ve sektör sertifikalarını profiline ekle, öne çık.' },
    { icon: '📄', title: 'CV Analizi', desc: 'CV\'n yüklenir, beceriler otomatik çıkarılır, profilin güçlenir.' },
    { icon: '🔔', title: 'Anlık Bildirimler', desc: 'Bir üye şirket sana ulaştığında anında bildirim al.' },
  ];

  const companyFeatures = [
    { icon: '🔍', title: 'Nitelikli Aday Havuzu', desc: 'Üniversite, bölüm, beceri, GPA ve sertifikaya göre filtrelenmiş adaylar.' },
    { icon: '📬', title: 'Doğrudan Davet', desc: 'Beğendiğin adaya kümeleme üyeliğinizin gücüyle doğrudan ulaş.' },
    { icon: '🤝', title: 'Ekosistem Desteği', desc: 'Türkiye Siber Güvenlik Kümelenmesi üye şirketleri arasında ortak staj kültürü ve işbirliği ortamı.' },
    { icon: '⚡', title: 'Basit Süreç', desc: 'Başvuruları tek ekrandan yönet, kararlarını hızla ilet.' },
  ];

  const steps = [
    { n: '01', title: 'Profilini Oluştur', desc: 'Üniversite, beceriler, sertifikalar ve CTF platformlarını ekle.' },
    { n: '02', title: 'Eşleşme Al', desc: 'Sistem profilini analiz eder, Türkiye Siber Güvenlik Kümelenmesi üye şirketlerimizi sana önerir.' },
    { n: '03', title: 'Staja Başla', desc: 'Şirketin davetini kabul et, siber güvenlik kariyerine ilk adımı at.' },
  ];

  const fmt = (v) => {
    if (stats === null) return '...';
    if (v === null || v === undefined) return '—';
    return parseInt(v).toLocaleString('tr-TR');
  };

  return (
    <div style={{ fontFamily: 'Inter, system-ui, sans-serif', minHeight: '100vh', background: '#0f172a', color: '#fff' }}>

      {/* Header */}
      <header style={{ padding: isMobile ? '0 14px' : '0 40px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, borderBottom: '1px solid rgba(255,255,255,0.08)', position: 'sticky', top: 0, background: 'rgba(15,23,42,0.95)', backdropFilter: 'blur(8px)', zIndex: 50 }}>
        <img src="/siberkume-logo.png" alt="Türkiye Siber Güvenlik Kümelenmesi" style={{ height: isMobile ? 36 : 52, flexShrink: 0, filter: 'brightness(0) invert(1)' }} />
        <div style={{ display: 'flex', gap: isMobile ? 6 : 10, flexShrink: 0 }}>
          <Link to="/login" style={{ padding: isMobile ? '7px 11px' : '8px 18px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.2)', color: '#e2e8f0', textDecoration: 'none', fontSize: isMobile ? 12 : 14, fontWeight: 500, whiteSpace: 'nowrap' }}>{isMobile ? 'Öğrenci' : 'Öğrenci Girişi'}</Link>
          <Link to="/sirket-giris" style={{ padding: isMobile ? '7px 11px' : '8px 18px', borderRadius: 8, background: '#2563eb', color: '#fff', textDecoration: 'none', fontSize: isMobile ? 12 : 14, fontWeight: 600, whiteSpace: 'nowrap' }}>{isMobile ? 'Şirket' : 'Şirket Girişi'}</Link>
        </div>
      </header>

      {/* Hero */}
      <section style={{ padding: '90px 24px 70px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(37,99,235,0.15) 0%, transparent 70%)', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />

        <div style={{ position: 'relative', maxWidth: 760, margin: '0 auto' }}>
          <span style={{ display: 'inline-block', padding: '6px 16px', borderRadius: 20, background: 'rgba(37,99,235,0.15)', border: '1px solid rgba(37,99,235,0.4)', color: '#60a5fa', fontSize: 12, fontWeight: 600, letterSpacing: 1, marginBottom: 24 }}>
            TÜRKİYE SİBER GÜVENLİK KÜMELENMESİ · STAJ PLATFORMU
          </span>
          <h1 style={{ fontSize: 'clamp(34px, 6vw, 58px)', fontWeight: 800, lineHeight: 1.1, margin: '0 0 20px', background: 'linear-gradient(135deg, #fff 40%, #60a5fa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Türkiye Siber Güvenlik Kümelenmesi<br />Üye Şirketlerimiz ile Öğrencileri Buluşturuyoruz
          </h1>
          <p style={{ fontSize: 17, color: '#94a3b8', lineHeight: 1.8, maxWidth: 580, margin: '0 auto 40px' }}>
            Bu platform yalnızca <strong style={{ color: '#e2e8f0' }}>Türkiye Siber Güvenlik Kümelenmesi üyesi şirketler</strong> ile siber güvenlik alanında kariyer hedefleyen öğrenciler arasında staj sürecini yürütmek için geliştirilmiştir.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" style={{ padding: '14px 32px', background: '#2563eb', color: '#fff', borderRadius: 10, fontSize: 16, fontWeight: 700, textDecoration: 'none', boxShadow: '0 0 24px rgba(37,99,235,0.4)' }}>
              Öğrenci Olarak Kayıt Ol →
            </Link>
            <Link to="/sirket-kayit" style={{ padding: '14px 32px', background: 'rgba(255,255,255,0.06)', color: '#e2e8f0', borderRadius: 10, fontSize: 16, fontWeight: 600, textDecoration: 'none', border: '1px solid rgba(255,255,255,0.15)' }}>
              Üye Şirket Girişi
            </Link>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section style={{ padding: '0 24px 70px' }}>
        <div style={{ maxWidth: 700, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1, background: 'rgba(255,255,255,0.08)', borderRadius: 16, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
          {[
            { value: fmt(stats?.total_students), label: 'Kayıtlı Öğrenci' },
            { value: '—', label: 'Üye Şirketimiz' },
            { value: '—', label: 'Aktif Staj İlanı' },
          ].map((s, i) => (
            <div key={i} style={{ padding: '28px 20px', textAlign: 'center', background: 'rgba(15,23,42,0.8)' }}>
              <div style={{ fontSize: 36, fontWeight: 800, color: '#60a5fa', lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#64748b', marginTop: 6 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* TSGK açıklama bandı */}
      <section style={{ padding: '36px 24px', background: 'rgba(37,99,235,0.06)', borderTop: '1px solid rgba(37,99,235,0.15)', borderBottom: '1px solid rgba(37,99,235,0.15)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'flex', alignItems: 'flex-start', gap: 20, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 32 }}>🔒</div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#e2e8f0', marginBottom: 8 }}>Bu platform yalnızca Türkiye Siber Güvenlik Kümelenmesi ekosistemine özeldir</div>
            <div style={{ fontSize: 14, color: '#94a3b8', lineHeight: 1.7 }}>
              Şirket başvuruları Türkiye Siber Güvenlik Kümelenmesi tarafından incelenir ve onaylanır. Platforma yalnızca kümeleme üyesi şirketlerimiz erişebilir. Öğrenciler ise siber güvenlik alanında faaliyet gösteren, güvenilirliği doğrulanmış bu şirketlerle buluşur.
            </div>
          </div>
        </div>
      </section>

      {/* Nasıl Çalışır */}
      <section style={{ padding: '70px 24px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 26, fontWeight: 700, textAlign: 'center', marginBottom: 8 }}>Nasıl Çalışır?</h2>
          <p style={{ textAlign: 'center', color: '#64748b', marginBottom: 48, fontSize: 15 }}>Öğrenciler için üç adımda staj fırsatı</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20 }}>
            {steps.map((step, i) => (
              <div key={i} style={{ padding: 28, borderRadius: 14, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', position: 'relative' }}>
                <div style={{ fontSize: 42, fontWeight: 900, color: 'rgba(37,99,235,0.2)', position: 'absolute', top: 16, right: 20, lineHeight: 1 }}>{step.n}</div>
                <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8, color: '#e2e8f0' }}>{step.title}</div>
                <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Özellikler */}
      <section style={{ padding: '20px 24px 70px' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 420px), 1fr))', gap: 40 }}>
          <div>
            <div style={{ display: 'inline-flex', padding: '6px 14px', borderRadius: 8, background: 'rgba(37,99,235,0.1)', border: '1px solid rgba(37,99,235,0.3)', marginBottom: 20 }}>
              <span style={{ color: '#60a5fa', fontSize: 13, fontWeight: 600 }}>🎓 Öğrenciler için</span>
            </div>
            <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24, color: '#f1f5f9' }}>Kariyerine güçlü bir başlangıç yap</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {studentFeatures.map((f, i) => (
                <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>{f.icon}</span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 3 }}>{f.title}</div>
                    <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/register" style={{ display: 'inline-block', marginTop: 28, padding: '11px 24px', background: '#2563eb', color: '#fff', borderRadius: 9, fontSize: 14, fontWeight: 600, textDecoration: 'none' }}>
              Hemen Kayıt Ol →
            </Link>
          </div>

          <div>
            <div style={{ display: 'inline-flex', padding: '6px 14px', borderRadius: 8, background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', marginBottom: 20 }}>
              <span style={{ color: '#34d399', fontSize: 13, fontWeight: 600 }}>🏢 Türkiye Siber Güvenlik Kümelenmesi Üye Şirketleri için</span>
            </div>
            <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 24, color: '#f1f5f9' }}>Doğru adayı hızla bul</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {companyFeatures.map((f, i) => (
                <div key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }}>{f.icon}</span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 3 }}>{f.title}</div>
                    <div style={{ fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/sirket-kayit" style={{ display: 'inline-block', marginTop: 28, padding: '11px 24px', background: 'rgba(16,185,129,0.12)', color: '#34d399', borderRadius: 9, fontSize: 14, fontWeight: 600, textDecoration: 'none', border: '1px solid rgba(16,185,129,0.3)' }}>
              Üye Şirket Başvurusu →
            </Link>
          </div>
        </div>
      </section>

      {/* Alt CTA */}
      <section style={{ padding: '60px 24px', background: 'linear-gradient(135deg, rgba(37,99,235,0.1), rgba(37,99,235,0.03))', borderTop: '1px solid rgba(37,99,235,0.15)' }}>
        <div style={{ maxWidth: 580, margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 26, fontWeight: 700, marginBottom: 12 }}>Siber güvenlik kariyerine<br />ilk adımı atmaya hazır mısın?</h2>
          <p style={{ color: '#94a3b8', marginBottom: 32, fontSize: 15, lineHeight: 1.7 }}>
            Türkiye Siber Güvenlik Kümelenmesi üye şirketlerimizin staj ilanlarına erişmek için hemen kayıt ol.
          </p>
          <Link to="/register" style={{ padding: '14px 36px', background: '#2563eb', color: '#fff', borderRadius: 10, fontSize: 16, fontWeight: 700, textDecoration: 'none', boxShadow: '0 0 24px rgba(37,99,235,0.35)' }}>
            Ücretsiz Kayıt Ol
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ padding: '28px 40px', borderTop: '1px solid rgba(255,255,255,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, color: '#475569', fontSize: 13 }}>
        <span>Türkiye Siber Güvenlik Kümelenmesi</span>
        <div style={{ display: 'flex', gap: 20 }}>
          <Link to="/login" style={{ color: '#475569', textDecoration: 'none' }}>Öğrenci Girişi</Link>
          <Link to="/sirket-giris" style={{ color: '#475569', textDecoration: 'none' }}>Şirket Girişi</Link>
          <Link to="/kvkk" style={{ color: '#475569', textDecoration: 'none' }}>KVKK</Link>
        </div>
        <span>© 2026 Türkiye Siber Güvenlik Kümelenmesi · Tüm hakları saklıdır.</span>
      </footer>

    </div>
  );
};

export default LandingPage;
